import * as Actions from './member-secondary-work-address.actions';

export const MemberSecondaryWorkAddressActions = Actions